import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import Rooms from "@/components/hotel/Rooms";
import Footer from "@/components/hotel/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const RoomsPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Zimmer & Apartments"
        description="Entdecken Sie unsere komfortablen Zimmer und geräumigen Apartments im ESOS Hotel Quelle Bad Ragaz – Familienzimmer, Doppelzimmer, Suiten und mehr."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Zimmer", path: "/rooms" },
        ]}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.rooms.title} subtitle={t.subpageHeroes.rooms.subtitle} />
      <Rooms />
      <Footer />
    </main>
  );
};

export default RoomsPage;
